import {trackError} from '@cohort/wallet/lib/Tracking';
import {getFileFromUrl} from '@cohort/wallet/lib/Utils';

export function canShare(): boolean {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return navigator.canShare !== undefined;
}

export type ShareNftLocation = 'nftDetailPage' | 'orderConfirmationModal';

export async function shareNft(
  merchantName: string,
  assetTitle: string,
  imageUrl: string,
  location: ShareNftLocation,
  reference: Record<string, string | number>,
  isRetry?: boolean
): Promise<void> {
  const files = [];
  try {
    files.push(await getFileFromUrl(imageUrl, assetTitle));
  } catch (err: unknown) {
    trackError(err);
  }
  const shareData = {
    files,
    title: `Checkout my ${merchantName} NFT!`,
    text: `I just got the ${assetTitle} NFT from ${merchantName} on Cohort!`,
  };

  if (canShare()) {
    try {
      await navigator.share(shareData);
    } catch (err: unknown) {
      const error = err as {toString: () => string};
      if (error.toString().includes('AbortError')) {
        return;
      }
      if (error.toString().includes('NotAllowedError')) {
        // This is a known iOS bug that can be fixed by retrying the share operation.
        if (isRetry) {
          throw new Error('NotAllowedError');
        } else {
          await shareNft(merchantName, assetTitle, imageUrl, location, reference, true);
        }
      }
      throw err;
    }
  }
}
